"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectCancelledEventArgs = void 0;
const EventType_1 = require("../EventType");
class EffectCancelledEventArgs {
    constructor(effectId) {
        this.effectId = effectId;
        this.__type = EventType_1.EventType.EffectCancelled;
        this.__typeName = "EffectCancelled";
    }
}
exports.EffectCancelledEventArgs = EffectCancelledEventArgs;
